/* src/locations/selectors.js */

import { createSelector } from 'reselect';
import _ from 'lodash';
import { loadTexts } from '../../config/texts';

export const getLocations = createSelector(
  state => state.locations.main.browse,
  state => state.locations.main.byID,
  state => state.appState.locale,
  (browse, byID, locale) => {
    const texts = loadTexts('location', locale);
    const { fields } = texts;

    return _.map(browse.IDs, id => {
      const { name, address, type, _id } = byID[id];
      return {
        [fields.location_name]: name,
        [fields.address]: address,
        [fields.type]: type, 
        _id
      };
    })
  }
);

export const fetchLocationsState = createSelector(
  state => state.locations.main.browse,
  ({ loading, error }) => ({ loading, error })
);

export const getLocationsListRange = createSelector(
  state => state.locations.main.browse,
  ({ start, end, count }) => ({ start, end, count })
);

export const getUniversities = createSelector(
  state => state.auth.data.user.universities,
  universities => _.map(universities, u => u._id)
);



// WEBPACK FOOTER //
// ./src/modules/locations/selectors.js